import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { useTranslation } from 'react-i18next';
import PersonalInfoService from 'src/services/personal-info.service';

export const useUpdateSecurityAnswer = (): UseMutationResult<any, Error, any, void> => {
  const { t } = useTranslation();
  return useMutation((formattedValues: any) => PersonalInfoService.updateSecurityAns(formattedValues), {
    onSuccess: () => {
      AlertAdapter(t('messages.securityUpdateSuccess'), 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
};
